<template>
    <gi-form
        v-if="form"
        ref="form"
        :form="form"
        :on-submit-fn="onSubmitFn"
        :history="history"
        :hide-actions="hideActions"
        @success="onSuccess"
        @error="onError"
        @form-error="onFormError"
        @load-history="onLoadHistory"
        @start-history-autosave="startHistoryAutosave"
        @stop-history-autosave="stopHistoryAutosave"
    >
        <template v-if="!hideHeader" #header>
            <app-page-header class="mb-4" />
        </template>
        <template #fields="{ loading }">
            <field-group-organisation
                ref="organisation"
                :value="form"
                :loading="loading"
                show-email
                @input="setFormData"
            />

            <field-bank-accounts
                ref="bank_accounts"
                v-model="form.bank_accounts"
                :label="$t('bank_accounts')"
                :disabled="isAdviser() && !isGrowthInvest()"
            />

            <field-adviser-accounts
                ref="adviser_accounts"
                v-model="form.adviser_accounts"
                :label="$t('adviser_accounts')"
                :disabled="loading"
            />

            <field-enum
                v-if="isGrowthInvest()"
                v-model="form.investor_structure"
                :disabled="loading"
                :enums="InvestorStructureEnum"
                enum-a11y-key="enums.investor_structure"
                :label="$t('investor_structure')"
            />

            <app-alert alert-type="info" class="mb-7">
                <h3 class="mb-4">Categorisation</h3>
                <field-investor-category v-model="form.category" :disabled="loading" :label="$t('category')" required />
                <p>{{ $t('categorisation_expiration_date_warning') }}</p>
                <field-date
                    ref="category_expires_on"
                    v-model="form.category_expires_on"
                    :disabled="loading"
                    :label="$t('enter_the_categorisation_expiration_date')"
                    :rules="[
                        getValidator('before')(
                            form.category_expires_on,
                            $t('categorisation_expiration_date'),
                            form.max_categorisation_expiry_date
                        )
                    ]"
                />
            </app-alert>
        </template>
        <template v-if="prependCancelButton" #prepend-actions>
            <app-button-cancel @click="onCancel" />
        </template>
    </gi-form>
</template>

<script>
import form from '@/mixins/form';
import history from '@/mixins/history';
import { Investor } from '@/models';
import InvestorStructureEnum from '@/enums/investor/structure';

export default {
    name: 'CreateInvestor',
    components: {
        GiForm: () =>
            import(
                /* webpackChunkName: "forms" */
                '@/components/forms/Form'
            ),
        FieldGroupOrganisation: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/groups/Organisation'
            ),
        FieldInvestorCategory: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/InvestorCategory'
            ),
        FieldBankAccounts: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/BankAccounts'
            ),
        FieldAdviserAccounts: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/AdviserAccounts'
            )
    },
    mixins: [form, history],
    data: () => ({
        id: 'CreateInvestor',
        model: Investor,
        updateRequestMethod: 'PATCH',
        InvestorStructureEnum
    })
};
</script>
